import React, { useState, useCallback, useEffect } from 'react';
import styled from 'styled-components';
import palette from '../../lib/styles/palette';
import { useSelector } from 'react-redux';

const TagBoxBlock = styled.div`
    width: 100%;
    max-width: 1280px;
    margin: 0 auto;
    // border-top: 1px solid ${palette.gray[2]};
    padding: 2rem 1rem 0;

    h4 {
        color: ${palette.gray[8]};
        margin-top: 0;
        margin-bottom: 0.5rem;
    }
`;

const TagForm = styled.form`
    border-radius: 4px;
    overflow: hidden;
    display: flex;
    width: 256px;
    border: 1px solid ${palette.gray[9]};
    input,
    button {
        outline: none;
        border: none;
        font-size: 1rem;
    }

    input {
        padding: 0.5rem;
        flex: 1;
        min-width: 0;
    }
    
    button {
        cursor: pointer;
        padding-right: 1rem;
        padding-left: 1rem;
        border: none;
        background: ${palette.gray[8]};
        color: white;
        font-weight: bold;
        &:hover {
            background: ${palette.gray[6]};
        }
    }
`;

const Tag = styled.div`
    margin-right: 0.5rem;
    color: ${palette.gray[6]};
    cursor: pointer;
    &:hover {
        opacity: 0.5;
    }
`;

const TagListBlock = styled.div`
    display: flex;
    margin-top: 0.5rem;
`;

// React.memo를 사용하여 tag값이 바뀔 때만 리렌더링되도록 처리
/*
    onClick={() => onRemove(tag)} 하지 않아서 계속 에러 났었음. 
*/
const TagItem = React.memo(({ tag, onRemove }) => (<Tag onClick={() => onRemove(tag)}>#{tag}</Tag>));

// React.memo를 사용하여 tags값이 바뀔 때만 리렌더링되로록 처리
const TagList = React.memo(({ tags, onRemove }) => (
    <TagListBlock>
        {tags && tags.map(tag => (
            <TagItem key={tag} tag={tag} onRemove={onRemove} />
        ))}
    </TagListBlock>
));

const TagBox = ({ onChangeTags, tags }) => {
    const [input, setInput] = useState('');
    const [localTags, setLocalTags] = useState([]);

    const language = useSelector(state => state.language.language);
    const isKR = language === 'KR' ? true : false;
    const isJP = language === 'JP' ? true : false;
    const isEN = language === 'EN' ? true : false;


    const insertTag = useCallback(
        tag => {
            if (!tag) return;   // 공백이라면 추가하지 않음
            if (localTags.includes(tag)) return;    // 이미 존재한다면 추가하지 않음
            const nextTags = [...localTags, tag];
            setLocalTags(nextTags);
            onChangeTags(nextTags);
        },
        [localTags, onChangeTags]
    );

    const onRemove = useCallback(
        tag => {
            const nextTags = localTags.filter(t => t !== tag);
            setLocalTags(nextTags);
            onChangeTags(nextTags);
        },
        [localTags, onChangeTags]
    );

    const onChange = useCallback(e => {
        setInput(e.target.value);
    }, []);

    const onSubmit = useCallback(
        e => {
            e.preventDefault();
            insertTag(input.trim());    // 앞뒤 공백을 제거한 후 등록
            setInput('');   // input 초기화
        }, [input, insertTag]
    );

    // tags 값이 바뀔 때
    useEffect(() => {
        setLocalTags(tags);
    }, [tags]);

    return (
        <TagBoxBlock>
            <h4>태그</h4>
            <TagForm onSubmit={onSubmit}>
                <input 
                    placeholder={isKR ? '태그를 입력하세요' : isJP ? 'タグを入力してください' : isEN ? 'Input Tag' : ''} 
                    value={input}
                    onChange={onChange}
                />
                <button type="submit">{isKR ? '추가' : isJP ? '追加' : isEN ? 'Add' : '' }</button>
            </TagForm>
            <TagList tags={localTags} onRemove={onRemove} />
        </TagBoxBlock>
    );
};

export default TagBox;